var _style, _g, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPapergreats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#040404;}\n\t.st1{fill:#212121;}\n\t.st2{fill:#1E1E1E;}\n\t.st3{fill:#111111;}\n\t.st4{fill:none;}\n\t.st5{font-family:'MyriadPro-Regular';}\n\t.st6{font-size:12px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "J9Z3Wv.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.6,99.7c-1.5,0.6-0.2,2.7-1.7,3.3c-0.2-1.2-0.5-2.4-0.6-3.6c-2.3-18.1-17.6-32.1-35.9-32.7 c-18.6-0.6-34,11.6-37.8,29.7c-1.1,5.2-0.9,10.2,1.7,14.9c6.7,11.9,16.6,18.9,30.6,19c3.8,0,4.5,1.3,4.3,4.7 c-0.2,6.2-0.1,12.4-0.1,19.3c6-4.9,11.1-9.4,16.6-13.4c11.8-8.7,19.6-19.8,21.2-34.7c0.6,0.5,1.1,1.1,1.7,1.6 c0,1.3-0.1,1.6-0.3,3.3c-0.4,1.1-0.7,2.2-0.9,3c-2.4,9.8-7.7,17.6-15.5,23.9c-6.5,5.2-12.8,10.7-19.4,15.8 c-2.4,1.9-3.5,3.9-3.5,7.1c0.1,64,0.1,127.9,0.2,191.9c0,2.9-0.5,3.9-3.7,3.9c-10.5-0.2-21-0.1-31.5-0.1c-5.1,0-5.1,0-5.1-5.3 c0-52.3,0-104.5,0-156.8c0-1.4,0.4-2.9-0.5-4.4c-4,2-5.9,4.6-5.8,9.4c0.4,13.7,0.1,27.5,0.1,41.2c0,24,0,47.9,0.1,71.9 c0,16-3.8,30.6-15,42.6c-0.3-0.4-0.7-0.7-1-1.1c11-14.4,15.9-30.5,13.3-48.8c-1.7-11.8-8-19.9-18.3-25.4 c-10.1-5.3-16.6-13.5-18.5-24.9c-1.3-7.8-0.4-15.6-0.6-23.4c0-1.4,0.4-2.8-0.5-4.4c-4.8,3.9-9.4,7.6-14,11.3 c-13.8,11.3-27.7,22.6-41.5,34c-33.8,28-23,80.1,13.6,96c6.6,2.9,13.6,4.2,20.6,5.1c-0.8,0.6-1.6,1.1-2.4,1.7c-1.3,0-2.7,0-4,0 c-1-1.5-2.6-1.1-4-1.4c-21.8-5.5-36.8-18.8-43.3-40.4c-6.6-21.8-2.1-41.5,13.8-58.2c4.6-4.9,9.9-9.1,15.2-13.3 c14.5-11.8,29-23.6,43.7-35.2c2.1-1.7,2.8-3.5,2.8-6.1c-0.1-55.5,0-111-0.2-166.5c0-1.9-0.1-4.5-0.1-4.5s2.9-0.1,4.7-0.1 c9.9,0.3,19.9,0.1,29.9,0.1c2.9,0,5.7,0.2,5.7,0.2s0,2.6,0,5.4c0,43.8,0,87.6,0,131.4c0,1.4,0,2.9,0,4.9c4-2.4,6.3-4.6,6.3-9.6 c-0.3-25.3-0.2-50.7-0.1-76c0.1-19.5,13.5-36.6,31.5-40.3c21.3-4.3,41.1,7.9,46.9,28.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.9,360.1c-8.3,8-18.3,12.4-29.5,14.4c-0.7,0.1-1.7-0.3-2,0.8c-0.5,0-1.1,0-1.6,0c-0.9-1.7-3.2,0.1-4-1.7 c13.6-1,25.6-5.9,36.2-14.6C246.2,359.4,246.5,359.8,246.9,360.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.7,373.7c0.9,1.7,3.2-0.1,4,1.7c-3.8,0-7.5,0-11.3,0c0.8-0.6,1.6-1.1,2.4-1.7 C206.5,373.7,208.1,373.7,209.7,373.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350.8,102.9c1.5-0.6,0.2-2.7,1.7-3.3c0,2.7,0,5.4,0,8.1c-0.6-0.5-1.1-1.1-1.7-1.6 C350.8,105,350.8,104,350.8,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M245.9,359.1c1.6-1.7,3.3-3.3,4.9-5c0.3,0.4,0.7,0.7,1,1.1c-1.3,2-2.9,3.6-4.9,4.9 C246.5,359.8,246.2,359.4,245.9,359.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.2,345c0,6.4-5,11.6-11.3,11.7c-6.3,0.1-11.6-5.1-11.7-11.4c-0.1-6.4,5.1-11.8,11.3-11.8 C336.8,333.5,342.1,338.7,342.2,345z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.2,
    y: 379.4,
    className: "st4",
    width: 409.5,
    height: 96.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 40.231 387.8711)",
    className: "st5 st6"
  }, "Jerri hobdy")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapergreats);
export default __webpack_public_path__ + "static/media/papergreats.d7bc335087d71687b949a2c23acec3c2.svg";
export { ForwardRef as ReactComponent };